<template>
  <div class="fetching-group" :class="{'mini' : mini}">
    <span class="fetching"></span>
    <transition name="slide-fade" mode="out-in" v-if="!mini">
      <p :key="current" class="message">{{ current }}</p>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      messages: [
        "Thinking in ones and zeros… mostly ones.",
        "Just calibrating my brainwaves for brilliance.",
        "Loading thoughts... human-friendly ones.",
        "Cooking up something with extra logic.",
        "Translating digital sparks into real ideas.",
        "Spinning up some cleverness behind the scenes.",
        "Polishing responses with invisible hands.",
        "Connecting the creative circuits...",
        "Mentally high-fiving your patience.",
        "Optimising cleverness levels..."
      ],
      interval: null,
      trackIdx: 0,
      mini: false,
    };
  },
  computed: {
    current() {
      return this.messages[this.trackIdx];
    }
  },
  mounted() {
    this.messages = this.messages.sort( () => .5 - Math.random() ); // SHANTY!
    this.start();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    start() {
      this.interval = setInterval(() => {
        this.trackIdx = (this.trackIdx + 1) % this.messages.length;
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/v5.scss';

.fetching-group {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 100vh;
  z-index: 9999999;
  background: $neutral-600;

  &.mini {
    position: relative;
  }

  .darkmode & {
    background: $neutral-100;
  }
}

.fetching {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  animation: rotate 1s linear infinite;

  &:before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    animation: prixClipFix 2s linear infinite;
    border: 5px solid $neutral-100;

    .darkmode & {
      border: 5px solid $neutral-600;
    }
  }
}

.message {
  max-width: 12rem;
  text-align: center;
  font-size: 1rem;
  line-height: 140%;
  margin-top: 1rem;
  color: $neutral-100;

  .darkmode & {
    color: $neutral-600;
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-enter {
  opacity: 0;
  transform: translateY(10px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
  }
  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}
</style>
